import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from '../../../theme/layouts/layout.module';
import { DefaultComponent } from '../../../theme/pages/default/default.component';
import { NewBidDetailModule } from '../new-bid-details/newBidDetails.module';
import { NewBidDetailsComponent } from '../new-bid-details/new-bid-details.component';
import { NewDefaultPageComponent } from '../new-default-page/new-default-page.component';

const routes: Routes = [{
    'path': '',
    'component': NewBidDetailsComponent,
    // 'children': [{
    //     'path': '',
    //     'component': NewBidDetailsComponent
    // }],
},
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        LayoutModule,
        FormsModule,
        NewBidDetailModule
    ], exports: [
        RouterModule
    ], declarations: [
    ],
    providers: [appService, CommonService, DatePipe],
})
export class NewBidDetailRouteModule { }
